import { actionTypes, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { call, select, takeEvery } from 'redux-saga/effects'
import { linkWithExistingUser } from 'services/api/user'
import { Response } from 'utils/fetchApi'

function* linkExisting() {
  const data: Response<{ readonly linkId: string }> = yield call(linkWithExistingUser)

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  const { linkId } = data.response
  const config = yield select(selectors.config.getConfig)
  const language = yield select(selectors.app.getLanguage)
  const baseUrl = `${config.walletUrl}/${language}`
  const linkUrl = `${baseUrl}/#/open/link-account?link_id=${linkId}`
  window.open(linkUrl, '_blank')
}

function* linkNew() {
  const data: Response<{ readonly linkId: string }> = yield call(linkWithExistingUser)

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
  }

  // TODO do something with data
}

export default function* walletLinkMain() {
  yield takeEvery(actionTypes.walletLink.LINK_EXISTING_WALLET, linkExisting)
  yield takeEvery(actionTypes.walletLink.LINK_NEW_WALLET, linkNew)
}
